import { useState } from 'react';

import { useFormik } from 'formik';

import Button from 'components/Button/Button';

import { EToasterStatus, showToast } from '../../utils/showToast';
import { Modal } from '../Modal/Modal';

import { IMPORT_CSV_WRONG_SIZE_MESSAGE } from './constants/constants';
import { csvUploadSchema } from './constants/validationSchema';
import ImportCSVContent from './ImportCSVContent';
import { ImportCSVModalProps } from './types';

import './style.scss';

const ImportCSVModal = ({
  isOpen,
  onImportFile,
  onCloseModal,
  fileRef,
  fileKeyName
}: ImportCSVModalProps) => {
  const [isUploading, setIsUploading] = useState(false);

  const { submitForm, resetForm, setFieldValue } = useFormik({
    validateOnMount: true,
    validationSchema: csvUploadSchema,
    enableReinitialize: true,
    initialValues: {
      file: null
    },
    onSubmit: async (values, { resetForm }) => {
      const file = fileRef?.current?.files?.[0];
      const formData = new FormData();
      if (!file) return;
      if (file && file.size > 2000000) {
        showToast({
          message: IMPORT_CSV_WRONG_SIZE_MESSAGE,
          status: EToasterStatus.ERROR
        });
        return;
      }
      setIsUploading(true);

      formData.append(fileKeyName, file as any);

      onImportFile(formData);
      resetForm();
      setIsUploading(false);
    }
  });

  const handleClose = () => {
    resetForm();
    onCloseModal();
  };

  return (
    <Modal
      className="importCSVModal"
      isOpen={isOpen}
      onClose={handleClose}
      width="650px"
    >
      <div className="flex flex-col gap-6 w-full">
        <h2 className="text-2xl font-semibold text-gray-900">Import CSV</h2>
        
        <ImportCSVContent
          isUploading={isUploading}
          fileRef={fileRef}
          setFieldValue={setFieldValue}
        />
        
        <div className="flex justify-end gap-3">
          <Button
            variant="outline"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            variant="default"
            onClick={() => submitForm()}
            disabled={!fileRef?.current?.files?.length}
          >
            Import
          </Button>
        </div>
      </div>
    </Modal>
  );
};
export default ImportCSVModal;
